module.exports = __webpack_public_path__ + "static/media/dropdownBannerIcon.b02d7e72.svg";